import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const WorkInProgressIllustration = (props: SVGProps): JSX.Element => {
  const {
    title = 'WorkInProgressIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 156 136"
      {...restProps}
    >
      <title>{title}</title>
      <path
        d="M33.7831 106.215V110.882H32.8744V107.123H5.17389V110.882H4.26562V106.215H33.7831Z"
        fill="white"
      />
      <path
        d="M26.1098 91.6596H12.1562L12.9777 88.3086H25.0762L26.1098 91.6596Z"
        fill="white"
      />
      <path
        d="M27.7863 98.9917H10.4219L11.3712 95.6406H26.7963L27.7863 98.9917Z"
        fill="white"
      />
      <path
        d="M20.4767 77.3652C21.2876 77.3653 22.0015 77.9008 22.2266 78.68L30.3269 106.541L29.4542 106.794L21.3543 78.9334L21.3539 78.9326C21.2415 78.5427 20.884 78.2735 20.4767 78.2735H17.5689C17.1616 78.2735 16.8042 78.5427 16.6917 78.9326L16.6913 78.9334L8.59141 106.794L7.71875 106.541L15.819 78.68C16.0442 77.9008 16.758 77.3653 17.5689 77.3652H20.4767Z"
        fill="white"
      />
      <path
        d="M114.365 52.1363C114.365 51.4407 113.801 50.877 113.106 50.877H111.074C110.378 50.8771 109.815 51.4408 109.815 52.1363V54.4592H108.906V52.1363C108.906 50.939 109.877 49.9688 111.074 49.9688H113.106C114.303 49.9688 115.274 50.939 115.274 52.1363V54.4592H114.365V52.1363Z"
        fill="white"
      />
      <path
        d="M115.245 46.5885C115.245 44.843 113.83 43.4278 112.085 43.4278C110.339 43.4278 108.924 44.843 108.924 46.5885C108.924 48.3341 110.339 49.7492 112.085 49.7492C113.83 49.7492 115.245 48.3341 115.245 46.5885ZM116.154 46.5885C116.154 48.8358 114.332 50.6575 112.085 50.6575C109.837 50.6575 108.016 48.8358 108.016 46.5885C108.016 44.3412 109.837 42.5195 112.085 42.5195C114.332 42.5195 116.154 44.3412 116.154 46.5885Z"
        fill="white"
      />
      <path
        d="M46.9786 102.846V111.047H46.0703V102.846H46.9786Z"
        fill="white"
      />
      <path d="M46.9786 71.5371V85.768H46.0703V71.5371H46.9786Z" fill="white" />
      <path
        d="M46.0763 52.1363C46.0762 51.4407 45.5122 50.877 44.8166 50.877H42.7848C42.0892 50.8771 41.5255 51.4408 41.5255 52.1363V54.4592H40.6172V52.1363C40.6173 50.939 41.5875 49.9688 42.7848 49.9688H44.8166C46.014 49.9688 46.9845 50.939 46.9846 52.1363V54.4592H46.0763V52.1363Z"
        fill="white"
      />
      <path d="M41.5255 71.5371V85.768H40.6172V71.5371H41.5255Z" fill="white" />
      <path
        d="M41.5255 102.846V111.047H40.6172V102.846H41.5255Z"
        fill="white"
      />
      <path
        d="M46.9641 46.5885C46.9641 44.843 45.5489 43.4278 43.8034 43.4278C42.0578 43.4278 40.6427 44.843 40.6426 46.5885C40.6426 48.3341 42.0578 49.7492 43.8034 49.7492C45.5489 49.7492 46.9641 48.3341 46.9641 46.5885ZM47.8723 46.5885C47.8723 48.8358 46.0507 50.6575 43.8034 50.6575C41.5561 50.6575 39.7344 48.8358 39.7344 46.5885C39.7344 44.3412 41.5561 42.5195 43.8034 42.5195C46.0507 42.5195 47.8723 44.3412 47.8723 46.5885Z"
        fill="white"
      />
      <path
        d="M71.1226 54.457L56.9922 71.5359H66.3218L80.4522 54.457H71.1226Z"
        fill="currentColor"
      />
      <path
        d="M53.146 54.457L39.0156 71.5359H48.3452L62.4756 54.457H53.146Z"
        fill="currentColor"
      />
      <path
        d="M38.7265 54.4597C37.3747 54.4597 36.2812 55.5559 36.2812 56.905V62.7476L43.1384 54.457H38.7265V54.4597Z"
        fill="currentColor"
      />
      <path
        d="M117.231 71.5383C118.583 71.5383 119.677 70.4422 119.677 69.0931V63.4219L112.961 71.5383H117.231Z"
        fill="currentColor"
      />
      <path
        d="M117.232 54.457H108.435L94.3047 71.5359H103.634L117.724 54.506C117.566 54.4734 117.4 54.457 117.234 54.457H117.232Z"
        fill="currentColor"
      />
      <path
        d="M89.7761 54.457L75.6484 71.5359H84.9753L99.1057 54.457H89.7761Z"
        fill="currentColor"
      />
      <path
        d="M119.226 56.9054C119.226 55.8057 118.334 54.9141 117.235 54.9141H38.7276C37.628 54.9141 36.7364 55.8057 36.7364 56.9054V69.0937C36.7365 70.1933 37.628 71.0845 38.7276 71.0845H117.235C118.334 71.0845 119.226 70.1933 119.226 69.0937V56.9054ZM120.134 69.0937C120.134 70.695 118.836 71.9932 117.235 71.9932H38.7276C37.1263 71.9932 35.8282 70.695 35.8281 69.0937V56.9054C35.8281 55.304 37.1263 54.0059 38.7276 54.0059H117.235C118.836 54.0059 120.134 55.304 120.134 56.9054V69.0937Z"
        fill="white"
      />
      <path
        d="M71.1226 85.7676L56.9922 102.844H66.3218L80.4522 85.7676H71.1226Z"
        fill="currentColor"
      />
      <path
        d="M53.146 85.7676L39.0156 102.844H48.3452L62.4756 85.7676H53.146Z"
        fill="currentColor"
      />
      <path
        d="M38.7265 85.7683C37.3747 85.7683 36.2812 86.8645 36.2812 88.2136V94.0562L43.1384 85.7656H38.7265V85.7683Z"
        fill="currentColor"
      />
      <path
        d="M117.231 102.847C118.583 102.847 119.677 101.751 119.677 100.402V94.7305L112.961 102.847H117.231Z"
        fill="currentColor"
      />
      <path
        d="M117.232 85.7676H108.435L94.3047 102.846H103.634L117.724 85.8165C117.566 85.7839 117.4 85.7676 117.234 85.7676H117.232Z"
        fill="currentColor"
      />
      <path
        d="M89.7761 85.7676L75.6484 102.844H84.9753L99.1057 85.7676H89.7761Z"
        fill="currentColor"
      />
      <path
        d="M119.226 88.2159C119.226 87.1163 118.334 86.2247 117.235 86.2247H38.7276C37.628 86.2247 36.7364 87.1163 36.7364 88.2159V100.404C36.7365 101.504 37.628 102.395 38.7276 102.395H117.235C118.334 102.395 119.226 101.504 119.226 100.404V88.2159ZM120.134 100.404C120.134 102.006 118.836 103.304 117.235 103.304H38.7276C37.1263 103.304 35.8282 102.006 35.8281 100.404V88.2159C35.8281 86.6145 37.1263 85.3164 38.7276 85.3164H117.235C118.836 85.3164 120.134 86.6145 120.134 88.2159V100.404Z"
        fill="white"
      />
      <path d="M156 110.662V111.57H0V110.662H156Z" fill="white" />
      <path
        d="M143.267 96.6718C144.048 96.6023 144.911 96.7934 145.832 97.3731L146.137 97.5652L146.019 97.9055L145.59 97.7577L146.019 97.9063L146.019 97.9067C146.018 97.9072 146.018 97.9078 146.018 97.9084C146.018 97.9095 146.017 97.911 146.017 97.9125C146.016 97.9156 146.014 97.9194 146.012 97.9241C146.009 97.9335 146.004 97.9462 145.998 97.9618C145.986 97.9929 145.968 98.036 145.945 98.0884C145.898 98.1933 145.826 98.3374 145.727 98.5028C145.528 98.8323 145.211 99.256 144.74 99.621C143.766 100.375 142.225 100.805 139.954 99.881L139.484 99.6901L139.726 99.2439L140.125 99.4604C139.726 99.244 139.726 99.2436 139.726 99.2434V99.243C139.726 99.2427 139.727 99.2423 139.727 99.2418C139.727 99.2409 139.728 99.2398 139.729 99.2385C139.731 99.2357 139.733 99.2319 139.735 99.2273C139.74 99.2181 139.748 99.2051 139.757 99.1892C139.775 99.1574 139.802 99.1127 139.837 99.0576C139.906 98.9474 140.008 98.7947 140.141 98.6196C140.405 98.2713 140.801 97.823 141.319 97.4431C141.837 97.0624 142.492 96.7408 143.267 96.6718ZM145 97.944C144.373 97.621 143.823 97.5341 143.348 97.5764C142.781 97.6268 142.281 97.8639 141.856 98.1754C141.431 98.4876 141.096 98.8651 140.865 99.1693C140.849 99.19 140.834 99.2108 140.82 99.2306C142.514 99.7789 143.557 99.3875 144.184 98.9027C144.544 98.6244 144.791 98.296 144.948 98.0342C144.967 98.0031 144.984 97.9727 145 97.944Z"
        fill="white"
      />
      <path
        d="M134.764 101.206C135.82 100.945 136.699 101.034 137.419 101.346C138.133 101.655 138.653 102.167 139.025 102.691C139.397 103.215 139.631 103.765 139.773 104.178C139.844 104.386 139.893 104.564 139.925 104.69C139.94 104.753 139.951 104.804 139.959 104.84C139.963 104.858 139.966 104.873 139.968 104.883L139.971 104.899V104.901C139.971 104.901 139.971 104.902 139.524 104.981L139.971 104.902L140.06 105.401L139.554 105.435C137.108 105.598 135.781 104.705 135.094 103.683C134.761 103.188 134.593 102.686 134.508 102.311C134.466 102.123 134.444 101.964 134.432 101.849C134.426 101.792 134.422 101.746 134.421 101.712C134.42 101.696 134.419 101.682 134.419 101.672C134.419 101.667 134.419 101.663 134.419 101.66V101.653C134.419 101.653 134.419 101.652 134.873 101.647L134.419 101.652L134.414 101.293L134.764 101.206ZM137.058 102.18C136.62 101.99 136.07 101.899 135.373 102.009C135.38 102.041 135.387 102.075 135.395 102.111C135.462 102.409 135.593 102.799 135.847 103.176C136.29 103.833 137.156 104.533 138.936 104.545C138.929 104.522 138.922 104.497 138.914 104.473C138.79 104.111 138.59 103.647 138.285 103.217C137.98 102.788 137.58 102.406 137.058 102.18Z"
        fill="white"
      />
      <path
        d="M131.625 79.8828L134.799 86.079L137.133 91.5897H142.742L148.429 79.6489C148.429 79.6489 144.831 79.0532 142.837 82.4206L140.498 78.1746C140.234 77.6959 139.546 77.7041 139.293 78.1882L137.114 82.3444C137.114 82.3444 134.862 79.2382 131.625 79.8855V79.8828Z"
        fill="currentColor"
      />
      <path
        d="M139.05 78.0616C139.403 77.3869 140.364 77.3753 140.732 78.043L142.851 81.8905C143.87 80.4117 145.205 79.7707 146.316 79.5077C146.916 79.3656 147.45 79.3337 147.835 79.3371C148.028 79.3388 148.184 79.3491 148.294 79.3595C148.348 79.3646 148.391 79.37 148.421 79.374C148.436 79.3759 148.448 79.3777 148.456 79.3789L148.469 79.3806L148.47 79.381C148.47 79.381 148.471 79.381 148.426 79.648L148.471 79.381L148.826 79.4398L142.983 91.7051L142.91 91.8595H136.951L134.552 86.1951L131.476 80.1899L131.352 80.2147V78.76L131.773 79.5834C133.404 79.3283 134.777 79.9604 135.738 80.6515C136.24 81.0122 136.636 81.3933 136.907 81.684C136.964 81.7453 137.015 81.8029 137.061 81.8553L139.05 78.0616ZM140.258 78.3042C140.098 78.015 139.683 78.0196 139.53 78.3125L137.148 82.8559L136.892 82.5024L136.891 82.5016C136.891 82.5005 136.89 82.4986 136.888 82.4962C136.884 82.4913 136.878 82.4837 136.87 82.4734C136.854 82.4528 136.83 82.4216 136.798 82.3819C136.733 82.3024 136.637 82.1883 136.511 82.0528C136.258 81.7813 135.888 81.426 135.423 81.0911C134.563 80.4733 133.397 79.9395 132.035 80.0943L135.037 85.9545L135.042 85.9637L135.046 85.9728L137.31 91.318H142.568L148.014 79.884C147.958 79.8816 147.897 79.8788 147.831 79.8782C147.479 79.8751 146.989 79.9047 146.44 80.0347C145.347 80.2935 144.019 80.95 143.067 82.5574L142.826 82.9652L140.258 78.3042Z"
        fill="currentColor"
      />
      <path
        d="M137.94 91.8379C137.94 92.9389 138.835 93.8345 139.936 93.8345C141.037 93.8345 141.933 92.9412 141.933 91.8379H142.841C142.841 93.4436 141.538 94.7428 139.936 94.7428C138.333 94.7428 137.031 93.4406 137.031 91.8379H137.94Z"
        fill="white"
      />
      <path d="M140.338 94.2617V111.643H139.43V94.2617H140.338Z" fill="white" />
      <path
        d="M140.164 85.7287L143.67 87.9696L144.114 87.7167V89.3316L143.644 89.031L139.907 91.168L135.531 88.3745L139.92 85.5723L140.164 85.7287ZM137.219 88.3741L139.933 90.1066L142.78 88.4788L139.919 86.6503L137.219 88.3741Z"
        fill="black"
      />
      <path d="M109.815 71.5371V85.768H108.906V71.5371H109.815Z" fill="white" />
      <path d="M115.268 71.5371V85.768H114.359V71.5371H115.268Z" fill="white" />
      <path
        d="M109.815 102.846V111.117H108.906V102.846H109.815Z"
        fill="white"
      />
      <path
        d="M115.268 102.846V111.117H114.359V102.846H115.268Z"
        fill="white"
      />
      <path
        d="M54.6066 58.2792L76.2469 25.3319C77.0466 24.1133 78.8336 24.1133 79.6333 25.3319L101.274 58.2792C102.158 59.6256 101.192 61.4181 99.579 61.4181H56.2957C54.6828 61.4181 53.7172 59.6283 54.6012 58.2792H54.6066Z"
        fill="white"
      />
      <path
        d="M77.9406 55.8246C78.9606 55.8246 79.7875 54.9977 79.7875 53.9777C79.7875 52.9577 78.9606 52.1309 77.9406 52.1309C76.9206 52.1309 76.0938 52.9577 76.0938 53.9777C76.0938 54.9977 76.9206 55.8246 77.9406 55.8246Z"
        fill="black"
      />
      <path
        d="M79.3814 53.9776C79.3814 53.183 78.7371 52.539 77.9424 52.539C77.1479 52.5391 76.5039 53.183 76.5039 53.9776C76.5039 54.7722 77.1478 55.4165 77.9424 55.4166C78.7371 55.4166 79.3814 54.7723 79.3814 53.9776ZM80.1974 53.9776C80.1974 55.2229 79.1878 56.2325 77.9424 56.2325C76.6972 56.2325 75.6875 55.2229 75.6875 53.9776C75.6876 52.7324 76.6972 51.7227 77.9424 51.7227C79.1877 51.7227 80.1973 52.7323 80.1974 53.9776Z"
        fill="black"
      />
      <path
        d="M78.064 35.9824H78.0613C77.199 35.9824 76.5 36.6814 76.5 37.5437V46.8379C76.5 47.7002 77.199 48.3992 78.0613 48.3992H78.064C78.9263 48.3992 79.6253 47.7002 79.6253 46.8379V37.5437C79.6253 36.6814 78.9263 35.9824 78.064 35.9824Z"
        fill="black"
      />
      <path
        d="M79.2193 37.5435C79.2192 36.9067 78.7028 36.3906 78.0659 36.3906H78.063C77.4262 36.3907 76.9102 36.9067 76.9101 37.5435V46.8377C76.9101 47.4746 77.4262 47.991 78.063 47.9911H78.0659C78.7029 47.9911 79.2193 47.4747 79.2193 46.8377V37.5435ZM80.0352 46.8377C80.0352 47.9254 79.1535 48.807 78.0659 48.807H78.063C76.9755 48.8069 76.0938 47.9253 76.0938 46.8377V37.5435C76.0938 36.456 76.9756 35.5743 78.063 35.5742H78.0659C79.1535 35.5742 80.0351 36.456 80.0352 37.5435V46.8377Z"
        fill="black"
      />
    </svg>
  );
};

WorkInProgressIllustration.displayName = 'WorkInProgressIllustration';
